import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { Platform } from "react-native-web-internals";
import * as AnimatedImplementation from "./AnimatedImplementation";
import * as AnimatedMock from "./AnimatedMock";
import Image from "./components/AnimatedImage";
import ScrollView from "./components/AnimatedScrollView";
import Text from "./components/AnimatedText";
import View from "./components/AnimatedView";
var Animated = Platform.isTesting ? AnimatedMock : AnimatedImplementation;
var Animated_default = {
  Image,
  ScrollView,
  Text,
  View,
  ...Animated.default
};
export {
  Animated_default as default
};
//# sourceMappingURL=Animated.js.map
